module.exports = __webpack_public_path__ + "static/media/rome-4.d62afba5.jpg";